<template>
  <ControlUnit :title="$t('control.panel.bot_id')">
    <label class="input-input__unit">

      <div class="flex">
        <input
          class="input-input__input"
          type="text"
          name="bot-id"
          v-model="botId"
        />

         <button
          type="button"
          class="input-input__btn btn btn--prim"
          @click="reload"
        >
          OK
        </button>

      </div>
    </label>
  </ControlUnit>
</template>

<script>
import ControlUnit from './ControlUnit.vue';
import {useStore} from "vuex";
import {computed, onMounted} from "vue";
import useStateController from "@/views/Control/ControlPanel/ControlUnit/useStateController";
import useRouteController from "@/views/Control/ControlPanel/ControlUnit/useRouteController";
import {runAllWithData} from "@/helpers/functional";

export default {

  components: {
    ControlUnit,
  },

  setup() {

    const unitName = 'bot-id';

    const store = useStore();

    const botId = computed({
      get() {
        return store.state.control.botId;
      },
      set(val) {
        changeHandler({
          type: unitName,
          value: val,
        })

      }
    })

    const reload = function(){
      location.reload()
    }

    const { changeControlHandler } = useStateController();

    const { setRouteTypeValue, getRouterQueryValue } =
      useRouteController('Control');

    const changeHandler = runAllWithData(
      //changeControlHandler,
      setRouteTypeValue
    );

    onMounted(() => {
      const unitQueryValue = getRouterQueryValue(unitName);

      changeControlHandler({
        type: unitName,
        value: unitQueryValue,
      });
    });

    return {
      unitName,
      botId,
      reload,
      changeHandler,
    };
  },
};
</script>

<style scoped>
.flex {
  display: flex;
}

.flex button {
  margin: 0 0 0 5px;
}
</style>
